import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import AuthenticatedLayout from '../Layout/AuthenticatedLayout';
import Dashboard from '../../modules/dashboard/pages/Dashboard';
import UserList from '../../modules/user/pages/UserListPage';
import Unauthorized from '../pages/errors/Unauthorized';
import NotFound from '../pages/errors/NotFound';
import TenantListPage from '../../modules/tenant/pages/TenantListPage';
import TenantDetailPage from '../../modules/tenant/pages/TenantDetailPage';
import RoomList from '../../modules/room/pages/RoomListPage';
import EquipmentList from '../../modules/equipment/pages/EquipmentListPage';
import ManufacturerList from '../../modules/manufacturer/pages/ManufacturerList';
import LockerList from '../../modules/locker/pages/LockerListPage';
import TenantFormPage from '../../modules/tenant/pages/TenantFormPage';
import UserFormPage from '../../modules/user/pages/UserFormPage';
import UserDetailPage from '../../modules/user/pages/UserDetailPage';
import RoomDetailPage from '../../modules/room/pages/RoomDetailPage';
import EquipamentDetailPage from '../../modules/equipment/pages/EquipamentDetailPage';
import LockerDetailPage from '../../modules/locker/pages/LockerDetailPage';
import ManufacturerDetailPage from '../../modules/manufacturer/pages/ManufacturerDetailPage';
import RoomFormPage from '../../modules/room/pages/RoomFormPage';
import ManufacturerFormPage from '../../modules/manufacturer/pages/ManufacturerFormPage';
import { EquipmentProvider } from '../../modules/equipment/context/EquipmentContext';
import { LockerProvider } from '../../modules/locker/context/LockerContext';
import { LockerFormPage } from '../../modules/locker/pages/LockerFormPage';
import LockerCreateReservationPage from '../../modules/locker/pages/LockerCreateReservationPage';
import { EquipmentFormPage } from '../../modules/equipment/pages/EquipmentFormPage';
import VehicleList from '../../modules/vehicle/pages/VehicleListPage';
import VehicleDetailPage from '../../modules/vehicle/pages/VehicleDetailPage';
import { VehicleFormPage } from '../../modules/vehicle/pages/VehicleFormPage';
import PetList from '../../modules/pets/pages/PetListPage';
import PetDetailPage from '../../modules/pets/pages/PetDetailPage';
import PetFormPage from '../../modules/pets/pages/PetFormPage';
import { VehicleProvider } from '../../modules/vehicle/context/VehicleContext';
import { PetProvider } from '../../modules/pets/context/PetContext';
import { ManufacturerProvider } from '../../modules/manufacturer/context/ManufacturerContext';
import { RoomProvider } from '../../modules/room/context/RoomContext';
import { TenantProvider } from '../../modules/tenant/context/TenantContext';
import { UserProvider } from '../../modules/user/context/UserContext';
import VisitorListPage from '../../modules/visitors/pages/VisitorListPage';
import VisitorFormPage from '../../modules/visitors/pages/VisitorFormPage';
import { VisitorProvider } from '../../modules/visitors/context/VisitorContext';
import ReservationListPage from '../../modules/reservations/pages/ReservationListPage';
import ReservationFormPage from '../../modules/reservations/pages/ReservationFormPage';
import { ReservationProvider } from '../../modules/reservations/context/ReservationContext';
import ReservationDetailPage from '../../modules/reservations/pages/ReservationDetailPage';
import { AnnouncementProvider } from '../../modules/announcement/context';
import AnnouncementListPage from '../../modules/announcement/pages/AnnouncementListPage';
import AnnouncementFormPage from '../../modules/announcement/pages/AnnouncementFormPage';
import AnnouncementDetailPage from '../../modules/announcement/pages/AnnouncementDetailPage';
import { VisitorDetailPage } from '../../modules/visitors/pages/VisitorDetailPage';
import ResidentListPage from '../../modules/resident/pages/ResidentListPage';
import ResidentFormPage from '../../modules/resident/pages/ResidentFormPage';
import ResidentDetailPage from '../../modules/resident/pages/ResidentDetailPage';
import { ResidentProvider } from '../../modules/resident/context/ResidentContext';
import ReportListPage from '../../modules/reports/pages/ReportListPage';
import { ReportProvider } from '../../modules/reports/context/ReportContext';
import { DashboardProvider } from '../../modules/dashboard/context/DashboardContext';
import { OrderProvider } from '../../modules/orders/context/OrderContext';
import OrderListPage from '../../modules/orders/pages/OrderListPage';
import OrderDetailPage from '../../modules/orders/pages/OrderDetailPage';
import OrderFormPage from '../../modules/orders/pages/OrderFormPage';
import { SectorProvider } from '../../modules/sector/context';
import SectorListPage from '../../modules/sector/pages/SectorListPage';
import SectorFormPage from '../../modules/sector/pages/SectorFormPage';
import SectorDetailPage from '../../modules/sector/pages/SectorDetailPage';
import UnitListPage from '../../modules/units/pages/UnitListPage';
import UnitFormPage from '../../modules/units/pages/UnitFormPage';
import UnitDetailPage from '../../modules/units/pages/UnitDetailPage';
import { UnitProvider } from '../../modules/units/context';
import OrderDeliverPage from '../../modules/orders/pages/OrderDeliverPage';
import SettingsPage from '../../modules/settings/pages/SettingsPage';
import { SettingsProvider } from '../../modules/settings/context/SettingsContext';
import { WorkScheduleProvider } from '../../modules/timeclock/context';
import WorkScheduleListPage from '../../modules/timeclock/pages/TimeClockListPage';
import WorkScheduleDetailPage from '../../modules/timeclock/pages/TimeClockDetailPage';
import WorkScheduleFormPage from '../../modules/timeclock/pages/TimeClockFormPage';

export const PrivateRoutes: RouteObject[] = [
  {
    path: "/401",
    element: <Unauthorized />,
  },
 
  {
    path: "/404",
    element: <NotFound />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout>
          <DashboardProvider>
            <Dashboard/>
          </DashboardProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout>
        <DashboardProvider>
            <Dashboard/>
          </DashboardProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
  },
  {
    path: '/settings',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout>
          <SettingsProvider>
            <SettingsPage />
          </SettingsProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
  },
  {
    path: '/tenants',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout>
          <TenantProvider>
            <Outlet />
          </TenantProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <TenantListPage />,
      },
      {
        path: 'new',
        element: <TenantFormPage />,
      },
      {
        path: ':id',
        element: <TenantDetailPage />,
      },
      {
        path: ':id/edit',
        element: <TenantFormPage />,
      },
    ],
  },

  {
    path: '/users',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout>
        <UserProvider>
            <Outlet />
          </UserProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <UserList />,
      },
      {
        path: 'new',
        element: <UserFormPage />,
      },
      {
        path: ':id',
        element: <UserDetailPage />,
      },
      {
        path: ':id/edit',
        element: <UserFormPage />,
      },
    ],
  },
  {
    path: '/residents',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout>
          <ResidentProvider>
            <Outlet />
          </ResidentProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <ResidentListPage />,
      },
      {
        path: 'new',
        element: <ResidentFormPage />,
      },
      {
        path: ':id',
        element: <ResidentDetailPage />,
      },
      {
        path: ':id/edit',
        element: <ResidentFormPage />,
      },
    ],
  },
  {
    path: '/rooms',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout>
          <RoomProvider>
            <Outlet />
          </RoomProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <RoomList />,
      },
      {
        path: ':id',
        element: <RoomDetailPage />,
      },
      {
        path: ':id/edit',
        element: <RoomFormPage />,
      },
      {
        path: 'new',
        element: <RoomFormPage />,
      },
    ],
  },
  {
    path: '/equipments',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout> 
          <EquipmentProvider>
            <Outlet />
          </EquipmentProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <EquipmentList />,
      },
      {
        path: ':id',
        element: <EquipamentDetailPage />,
      },
      {
        path: ':id/edit',
        element: <EquipmentFormPage />,
      },
      {
        path: 'new',
        element: <EquipmentFormPage />,
      },
    ],
  },
  {
    path: '/vehicles',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout> 
          <VehicleProvider>
            <Outlet />
          </VehicleProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <VehicleList />,
      },
      {
        path: ':id',
        element: <VehicleDetailPage />,
      },
      {
        path: ':id/edit',
        element: <VehicleFormPage />,
      },
      {
        path: 'new',
        element: <VehicleFormPage />,
      },
    ],
  },
  {
    path: '/pets',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout> 
          <PetProvider>
            <Outlet />
          </PetProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <PetList />,
      },
      {
        path: ':id',
        element: <PetDetailPage />,
      },
      {
        path: ':id/edit',
        element: <PetFormPage />,
      },
      {
        path: 'new',
        element: <PetFormPage />,
      },
    ],
  },
  {
    path: '/lockers',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout>
          <LockerProvider>
          <Outlet />
          </LockerProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <LockerList />,
      },
      {
        path: 'new',
        element: <LockerFormPage />,
      },
      {
        path: 'reservation/:lockerId/new',
        element: <LockerCreateReservationPage />,
      },
      {
        path: 'reservation/:id/edit',
        element: <LockerCreateReservationPage />,
      },
      {
        path: ':id/edit',
        element: <LockerFormPage />,
      },
      {
        path: ':id',
        element: <LockerDetailPage />,
      },
    ],
  },
  {
    path: '/manufacturers',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout>
          <ManufacturerProvider>
          <Outlet />
          </ManufacturerProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <ManufacturerList />,
      },
      {
        path: ':id',
        element: <ManufacturerDetailPage />,
      },
      {
        path: ':id/edit',
        element: <ManufacturerFormPage />,
      },
      {
        path: 'new',
        element: <ManufacturerFormPage />,
      },
    ],
  },
  {
    path: '/visitors',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout>
          <VisitorProvider>
            <Outlet />
          </VisitorProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <VisitorListPage />,
      },
      {
        path: 'new',
        element: <VisitorFormPage />,
      },
      {
        path: ':id/edit',
        element: <VisitorFormPage />,
      },
      {
        path: ':id',
        element: <VisitorDetailPage  />,
      },
    ],
  },
  {
    path: '/reservations',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout>
          <ReservationProvider>
            <Outlet />
          </ReservationProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <ReservationListPage />,
      },
      {
        path: 'new',
        element: <ReservationFormPage />,
      },
      {
        path: ':id',
        element: <ReservationDetailPage />,
      },
      {
        path: ':id/edit',
        element: <ReservationFormPage />,
      },
    ],
  },
  {
    path: '/announcements',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout>
          <AnnouncementProvider>
            <Outlet />
          </AnnouncementProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <AnnouncementListPage />,
      },
      {
        path: 'new',
        element: <AnnouncementFormPage />,
      },
      {
        path: ':id',
        element: <AnnouncementDetailPage />,
      },
      {
        path: ':id/edit',
        element: <AnnouncementFormPage />,
      },
    ],
  },
  {
    path: '/reports',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout>
          <ReportProvider>
            <Outlet />
          </ReportProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <ReportListPage />,
      },
    ],
  },
  {
    path: '/orders',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout>
          <OrderProvider>
            <Outlet />
          </OrderProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <OrderListPage />,
      },
      {
        path: ':id',
        element: <OrderDetailPage />,
      },
      {
        path: 'new',
        element: <OrderFormPage />,
      },
      {
        path: ':id/edit',
        element: <OrderFormPage />,
      },
      {
        path: ':id/deliver',
        element: <OrderDeliverPage />,
      },
      
    ],
  },
  {
    path:'/vehicles',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout>
          <VehicleProvider>
            <Outlet />
          </VehicleProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <VehicleList />,
      },
      {
        path: 'new',
        element: <VehicleFormPage />,
      },
      {
        path: ':id/edit',
        element: <VehicleFormPage />,
      },
      {
        path: ':id',
        element: <VehicleDetailPage />,
      },
    ],
  },
  {
    path: '/sectors',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout>
          <SectorProvider>
            <Outlet />
          </SectorProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <SectorListPage />,
      },
      {
        path: 'new',
        element: <SectorFormPage />,
      },
      {
        path: ':id',
        element: <SectorDetailPage />,
      },
      {
        path: ':id/edit',
        element: <SectorFormPage />,
      },
    ],
  },
  {
    path: '/units',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout>
          <UnitProvider>
            <Outlet />
          </UnitProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <UnitListPage /> },
      { path: 'new', element: <UnitFormPage /> },
      { path: ':id', element: <UnitDetailPage /> },
      { path: ':id/edit', element: <UnitFormPage /> },
    ],
  },
  {
    path: '/timeclock',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout>
          <WorkScheduleProvider>
            <Outlet />
          </WorkScheduleProvider>
        </AuthenticatedLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <WorkScheduleListPage />,
      },
      {
        path: 'new',
        element: <WorkScheduleFormPage />,
      },
      {
        path: ':id',
        element: <WorkScheduleDetailPage />,
      },
      {
        path: ':id/edit',
        element: <WorkScheduleFormPage />,
      },
    ],
  },
];